import { BusinessLine } from "./CategoryPerformanceView";

export const defaultBusinessLines: BusinessLine[] = [];

export const yearlyApiResponse = {
  years: ["PY 21", "PY 22", "PY 23", "PY 24", "PY 25(YTD)"],
  categories: {
    beauty: {
      label: "Beauty",
      budget: [44000, 55000, 41000, 67000, 22000, 43000, 34000, 40000],
      bv: [42000, 52000, 40000, 64000, 21000, 41000, 34000, 40000],
    },
    catalog: {
      label: "Catalog",
      budget: [28000, 30000, 27000, 35000, 29000, 33000, 34000, 40000],
      bv: [26000, 29000, 25000, 33000, 27000, 31000, 34000, 40000],
    },
    durables: {
      label: "Durables",
      budget: [15000, 18000, 17000, 21000, 16000, 19000, 34000, 40000],
      bv: [14000, 17000, 16000, 20000, 15000, 18000, 34000, 40000],
    },
    nutrition: {
      label: "Nutrition",
      budget: [20000, 23000, 21000, 26000, 24000, 27000, 34000, 40000],
      bv: [19000, 22000, 20000, 25000, 23000, 26000, 34000, 40000],
    },
    personalCare: {
      label: "Personal Care",
      budget: [14500, 15500, 15000, 16500, 16000, 17000, 34000, 40000],
      bv: [13500, 14500, 14000, 15500, 15000, 16000, 34000, 40000],
    },
    homeCare: {
      label: "Home Care",
      budget: [12000, 14000, 13000, 16000, 15000, 17000, 34000, 40000],
      bv: [11000, 13000, 12000, 15000, 14000, 16000, 34000, 40000],
    },
    other: {
      label: "Other",
      budget: [6500, 7000, 6800, 7500, 7200, 7800, 34000, 40000],
      bv: [6000, 6500, 6300, 7000, 6700, 7200, 34000, 40000],
    },
    skinCare: {
      label: "Skin Care",
      budget: [6500, 7000, 6800, 7500, 7200, 7800, 34000, 40000],
      bv: [6000, 6500, 6300, 7000, 6700, 7200, 34000, 40000],
    },
    unknown: {
      label: "Unknown",
      budget: [6500, 7000, 6800, 7500, 7200, 7800, 34000, 40000],
      bv: [6000, 6500, 6300, 7000, 6700, 7200, 34000, 40000],
    },
  },
};

export const yearlyTableDataMock = {
  header: {
    row: [
      { kpiValue: "Year" },
      { kpiValue: "YOY Change ($)" },
      { kpiValue: "Yearly Total ($)" },
      { kpiValue: "YOY Change (BV)" },
      { kpiValue: "Yearly Total (BV)" },
    ],
  },
  body: {
    rows: [
      [
        {
          kpiValue: "Beauty",
          kpiDataType: "string",
          children: [
            [
              {
                kpiValue: "PY25 (YTD)",
                kpiDataType: "string",
                kpiCurrency: "USD",
              },
              { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 50000, kpiDataType: "currency", kpiCurrency: "USD" },
              { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 48000, kpiDataType: "currency", kpiCurrency: "USD" },
            ],
            [
              { kpiValue: "PY24", kpiDataType: "string", kpiCurrency: "USD" },
              { kpiValue: 20, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 67000, kpiDataType: "currency", kpiCurrency: "USD" },
              { kpiValue: 20, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 64000, kpiDataType: "currency", kpiCurrency: "USD" },
            ],
            [
              { kpiValue: "PY23", kpiDataType: "string", kpiCurrency: "USD" },
              { kpiValue: -18, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 41000, kpiDataType: "currency", kpiCurrency: "USD" },
              { kpiValue: -18, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 40000, kpiDataType: "currency", kpiCurrency: "USD" },
            ],
            [
              { kpiValue: "PY22", kpiDataType: "string", kpiCurrency: "USD" },
              { kpiValue: 25, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 55000, kpiDataType: "currency", kpiCurrency: "USD" },
              { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 52000, kpiDataType: "currency", kpiCurrency: "USD" },
            ],
            [
              { kpiValue: "PY21", kpiDataType: "string", kpiCurrency: "USD" },
              { kpiValue: 0, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 44000, kpiDataType: "currency", kpiCurrency: "USD" },
              { kpiValue: 0, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 42000, kpiDataType: "currency", kpiCurrency: "USD" },
            ],
          ],
        },
        { kpiValue: 14, kpiDataType: "percentage", kpiCurrency: "USD" },
        { kpiValue: 257000, kpiDataType: "currency", kpiCurrency: "USD" },
        { kpiValue: 14, kpiDataType: "percentage", kpiCurrency: "USD" },
        { kpiValue: 244000, kpiDataType: "currency", kpiCurrency: "USD" },
      ],
      [
        {
          kpiValue: "Catalog",
          kpiDataType: "string",
          children: [
            [
              {
                kpiValue: "PY25 (YTD)",
                kpiDataType: "string",
                kpiCurrency: "USD",
              },
              { kpiValue: -3, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 28000, kpiDataType: "currency", kpiCurrency: "USD" },
              { kpiValue: -4, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 26000, kpiDataType: "currency", kpiCurrency: "USD" },
            ],
            [
              { kpiValue: "PY24", kpiDataType: "string", kpiCurrency: "USD" },
              { kpiValue: 30, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 35000, kpiDataType: "currency", kpiCurrency: "USD" },
              { kpiValue: 32, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 33000, kpiDataType: "currency", kpiCurrency: "USD" },
            ],
            [
              { kpiValue: "PY23", kpiDataType: "string", kpiCurrency: "USD" },
              { kpiValue: -10, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 27000, kpiDataType: "currency", kpiCurrency: "USD" },
              { kpiValue: -14, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 25000, kpiDataType: "currency", kpiCurrency: "USD" },
            ],
            [
              { kpiValue: "PY22", kpiDataType: "string", kpiCurrency: "USD" },
              { kpiValue: 7, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 30000, kpiDataType: "currency", kpiCurrency: "USD" },
              { kpiValue: 12, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 29000, kpiDataType: "currency", kpiCurrency: "USD" },
            ],
            [
              { kpiValue: "PY21", kpiDataType: "string", kpiCurrency: "USD" },
              { kpiValue: 0, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 28000, kpiDataType: "currency", kpiCurrency: "USD" },
              { kpiValue: 0, kpiDataType: "percentage", kpiCurrency: "USD" },
              { kpiValue: 26000, kpiDataType: "currency", kpiCurrency: "USD" },
            ],
          ],
        },
        { kpiValue: 6, kpiDataType: "percentage", kpiCurrency: "USD" },
        { kpiValue: 148000, kpiDataType: "currency", kpiCurrency: "USD" },
        { kpiValue: 6, kpiDataType: "percentage", kpiCurrency: "USD" },
        { kpiValue: 139000, kpiDataType: "currency", kpiCurrency: "USD" },
      ],
    ],
  },
  kpiCurrency: "USD",
};
